/**
 * @generated SignedSource<<73a62ef9a61094e15b8a038f237171e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      }
    ],
    "concreteType": "TicketResponseType",
    "kind": "LinkedField",
    "name": "getTicketUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetTicketUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetTicketUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b37d6cf98a1af710aa06a814c1918f49",
    "id": null,
    "metadata": {},
    "name": "GetTicketUrlQuery",
    "operationKind": "query",
    "text": "query GetTicketUrlQuery(\n  $bookingId: String!\n) {\n  getTicketUrl(bookingId: $bookingId) {\n    url\n    status\n    message\n  }\n}\n"
  }
};
})();

node.hash = "2329aca4e7fc42b0537834110f7c83e7";

module.exports = node;
